import * as React from 'react';

export const HeaderCellTag: React.FC<{ text: string; classes: Record<string, string> }> = (
  props
) => {
  const { text, classes } = props;

  const classNames = {
    triangleLeft: text === 'FIRST' ? classes.triangleLeftGreen : classes.triangleLeft,
    headerCellTagContent:
      text === 'FIRST' ? classes.headerCellTagContentGreen : classes.headerCellTagContent,
    triangleRight: text === 'FIRST' ? classes.triangleRightGreen : classes.triangleRight,
  };

  return (
    <div className={classes.headerCellTag}>
      <div className={classNames.triangleLeft} />
      <div className={classNames.headerCellTagContent}>{text}</div>
      <div className={classNames.triangleRight} />
    </div>
  );
};
